import { addDays } from 'date-fns';
import { atom } from 'jotai';
import { PatientBasicsDto } from '../api/generated/model';
import { formatDateForInput } from '../utils/date.ts';

export enum HistoryFilter {
  ALL = 'ALL',
  JOURNAL = 'JOURNAL',
  UPDATES = 'UPDATES',
}

export const historyFilterAtom = atom<HistoryFilter>(HistoryFilter.ALL);
export const historyRangeFilterAtom = atom<{ from: string; until: string }>({
  from: formatDateForInput(addDays(new Date(), -30)),
  until: formatDateForInput(new Date()),
});

export const historySelectedPatientFilterAtom = atom<PatientBasicsDto | null>(null);
